import { useMemo } from 'react';
import { SegmentedValue } from 'antd/es/segmented';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import { getSegmentedOptions } from '../constants';

const getTab = (
  options: {
    label: string;
    value: string;
  }[],
  pathname: string,
) => options.find((o) => matchPath(o.value, pathname))?.value || options[0].value;

export const useTabs = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const options = getSegmentedOptions();

  const handleChange = (newTab: SegmentedValue) => {
    navigate(String(newTab));
  };
  const tab = useMemo(() => getTab(options, pathname), options);
  return {
    handleChange,
    currentTab: tab,
    options: getSegmentedOptions(),
  };
};
